export default {
  queryCriminal: '/v3/recruit/obsolete/info',
  getIsExistDdbit: '/gateway/capp/CourierAccountDebitFacade/isExistDebit'
}
